// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The main menu token.
 */
export const ISplashScreen = new Token('@jupyterlab/apputils:ISplashScreen');
//# sourceMappingURL=splash.js.map